module.exports = __webpack_public_path__ + "img/logo_gs.9164be8e.png";